/**
 * Voice Chat Provider Factory
 *
 * Factory pattern for creating voice chat provider instances.
 * This allows easy switching between providers without changing business logic.
 */

import { VoiceChatProvider } from '../../types/voice-chat-provider';
import { LiveKitProvider } from './providers/livekit-provider';

export class VoiceChatProviderFactory {
  /**
   * Create a voice chat provider instance based on provider type
   * @param providerType - The type of provider to create (e.g., "livekit", "twilio")
   * @returns A VoiceChatProvider instance
   * @throws Error if provider type is not supported
   */
  static create(providerType: string): VoiceChatProvider {
    switch (providerType.toLowerCase()) {
      case 'livekit':
        return new LiveKitProvider();
      default:
        throw new Error(`Unsupported provider: ${providerType}`);
    }
  }

  /**
   * Get list of supported provider types
   * @returns Array of supported provider type strings
   */
  static getSupportedProviders(): string[] {
    return ['livekit']; // Add more as implemented
  }
}
